import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { FluxibleComponent } from 'fluxible-addons-react';
import ddo from '@99designs/common/apps/ddo/index';
import models from 'apps/ddo/di';
import ErrorBoundary from 'components/ErrorBoundary';
import Fluxible from 'fluxible';
import OnlineStatusStore from 'stores/OnlineStatusStore';
import DesignDetailsSidebar from 'apps/ddo/components/DesignDetailsSidebar';
import history from 'utils/history';

document.addEventListener('DOMContentLoaded', () => {
    const appNode = document.getElementById('design-details-app');
    const dataNode = document.getElementById('ddo-app-data');
    const { initData } = JSON.parse(dataNode.textContent);
    const { activeUser, intlMessages, designCollection } = initData;
    const ddoPath = '/profiles/:parentId/designs/:designId';
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    window.REQUEST_TOKENS = {
        DESIGN_COMMENT_CREATE_FINISH: csrfToken,
        DESIGN_COMMENT_DELETE_FINISH: csrfToken,
        DESIGN_COMMENT_UPDATE: csrfToken,
        DESIGN_UPDATE_LIKE_STATUS: csrfToken,
    };

    const fluxibleApp = new Fluxible({
        stores: [OnlineStatusStore],
    });

    const fluxibleContext = fluxibleApp.createContext();
    const { DdoComponent } = ddo({
        fluxibleApp,
        fluxibleContext,
        activeUser,
        designCollection: models.designCollection.fromJSON(designCollection),
        isInline: false,
        models,
        goBack: () => {
            history.go(-1);
        },
        goTo: path => {
            history.replace(path);
        },
        csrfToken: document.querySelector('meta[name=csrf-token]').getAttribute('content'),
    });

    ReactDOM.render(
        <ErrorBoundary>
            <IntlProvider locale={document.documentElement.lang} messages={intlMessages}>
                <FluxibleComponent context={fluxibleContext.getComponentContext()}>
                    <Router history={history}>
                        <Switch>
                            <Route
                                path={ddoPath}
                                component={props => (
                                    <DdoComponent
                                        designId={props.match.params.designId}
                                        renderSidebar={sidebarProps => (
                                            <DesignDetailsSidebar
                                                activeUser={activeUser}
                                                {...sidebarProps}
                                            />
                                        )}
                                    />
                                )}
                            />
                            <Redirect
                                path="*"
                                to={{ ...window.location, pathname: window.location.pathname }}
                            />
                        </Switch>
                    </Router>
                </FluxibleComponent>
            </IntlProvider>
        </ErrorBoundary>,
        appNode
    );
});



// WEBPACK FOOTER //
// ./src/js/page/standalone-ddo.jsx